export default {
  // KycRecordHistory.tsx
  'kyc.history.title': 'KYC认证申请历史记录',
  'kyc.history.memberAccount': '会员账号',
  'kyc.history.realName': '真实姓名',
  'kyc.history.idPhoto': '身份证件',
  'kyc.infoImg.documentPhoto': '证件照',
  'kyc.infoImg.handheldPhoto': '手持证件照',
  'kyc.infoImg.selfiePhoto': '自拍照片',
  'kyc.infoImg.noPhoto': '没有照片',
  'kyc.history.viewPhoto': '查看照片',
  'kyc.history.birthDate': '出生日期',
  'kyc.history.documentType': '证件类型',
  'kyc.history.documentCode': '证件号码',
  'kyc.history.gender': '性别',
  'kyc.history.nationality': '国籍',
  'kyc.history.incomeSource': '收入来源',
  'kyc.history.monthlyIncomeRange': '月收入',
  'kyc.history.occupation': '职业',
  'kyc.history.currentAddress': '现住址',
  'kyc.history.permanentAddress': '永久住址',
  'kyc.history.birthAddress': '出生地',
  'kyc.history.info': '基本信息',
  'kyc.history.kycCount': '申请次数',
  'kyc.history.operation': '操作信息',
  'kyc.history.submitTime': '提交时间',
  'kyc.history.submitter': '提交人',
  'kyc.history.reviewTime': '审核时间',
  'kyc.history.reviewer': '审核人',
  'kyc.history.failureReason': '失败原因',
  'kyc.history.status': '状态',
  'kyc.history.status.simple.pending': '注册KYC待审核',
  'kyc.history.status.whole.pending': '提款KYC待审核',
  'kyc.history.status.simple.success': '注册KYC成功',
  'kyc.history.status.whole.success': '提款KYC成功',
  'kyc.history.status.simple.failed': '注册KYC失败',
  'kyc.history.status.whole.failed': '提款KYC失败',
  'kyc.history.status.simple.blacklist': '注册KYC黑名单',
  'kyc.history.status.whole.blacklist': '提款KYC黑名单',
  'kyc.history.status.unknown': '未知状态',

  'kyc.sup.status.pending': '未提交',
  'kyc.sup.status.submit': '已提交',
  'kyc.sup.status.rejected': '审核不通过',
  'kyc.sup.status.approved': '审核通过',
  'kyc.sup.approve.confirm.approve': '确认将该会员补充kyc信息申请设置为通过状态？',
  'kyc.sup.approve.confirm.reject': '确认将该会员补充kyc信息申请设置为不通过？',

  // KycRecordApprove.tsx
  'kyc.approve.title.success': '审核通过确认',
  'kyc.approve.title.reject': '审核拒绝确认',
  'kyc.update.title.document': '修改证件',
  'kyc.approve.confirm.success': '确认将该KYC认证申请设置为通过状态？',
  'kyc.approve.failureReason': '失败原因',
  'kyc.approve.failureReason.placeholder': '请输入失败原因',
  'kyc.approve.error.recordNotExist': '记录数据不存在',

  // KycRecordData.tsx
  'kyc.data.setSuccess': '置为成功',
  'kyc.data.setFailed': '置为失败',
  'kyc.data.viewFailureReason': '失败原因',
  'kyc.data.viewHistory': '历史数据',
  'kyc.data.document': '修改证件',
  'kyc.data.confirm.setFailed': '确认将该KYC认证申请置为失败？',
  'kyc.data.error.loadFailed': '数据加载失败',

  // KycRecordFrm.tsx
  'kyc.form.submitTime': '提交时间',
  'kyc.form.reviewTime': '审批时间',
  'kyc.form.memberAccount': '会员账号',
  'kyc.form.memberAccount.placeholder': '请输入会员账号',
  'kyc.form.status': '状态',
  'kyc.form.status.placeholder': '请选择状态',
  'kyc.form.status.pending': '待审核',
  'kyc.form.status.success': '已通过',
  'kyc.form.status.failed': '已拒绝',
  'kyc.form.batchSuccess': '批量置为成功',
  'kyc.form.batchFailed': '批量置为失败',
  'kyc.form.confirm.batchFailed': '确认将选中的KYC认证申请批量置为失败？',

  // 系统通用
  'sys.operation.title': '操作'
};
